import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Router from './router';
import { BrowserRouter } from 'react-router-dom';
import { AxiosProvider } from './contexts/axiosContext';
import { AuthProvider } from './contexts/authContext';
import { ToastContainer, toast } from "react-toastify";
import './assets/i18n/i18n';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <AxiosProvider>
    <AuthProvider>
      <BrowserRouter>
        <Router />
        <ToastContainer/>
      </BrowserRouter>
    </AuthProvider>
  </AxiosProvider>
);
